import isDefaultExport from '../is/is-default-export.js';
import isStringRecord from '../is/is-string-record.js';
export default function isDefaultStringRecordExport(value) {
    return isDefaultExport(value) && isStringRecord(value.default);
}
//# sourceMappingURL=is-default-string-record-export.js.map